import { render, staticRenderFns } from "./ContactFormTypeModalForm.vue?vue&type=template&id=011d5428"
import script from "./ContactFormTypeModalForm.vue?vue&type=script&lang=js"
export * from "./ContactFormTypeModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports